module.exports = __webpack_public_path__ + "img/image (91).51f2432b.jpg";